// extracted by mini-css-extract-plugin
export default {"title":"_1999c7c88d","inner_title":"_91f693aa76","charge_btn":"a0e7d46be2"};